import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";

export {init,destroy}
Html.registerWidget('widget/activity-filter',{init:init,destroy:destroy})

function onchange(){
  amplify.publish("activityFilterSelected",{filter:$(this).val()});
}

function init(obj){
  obj.on('change',onchange);
}
function destroy(obj){
  obj.off('change');
}